/* eslint-disable no-unused-vars */
/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/require-default-props */
import React from 'react';
import { useTranslation } from 'react-i18next';

import editIcon from 'src/assets/benefits-edit.svg';
import trashIcon from 'src/assets/benefits-trash.svg';

import { removeForbiddenWords } from 'src/utils/removeForbiddenWords';
import fallbackImageUrl from 'src/assets/empty_photo_benefit.jpg';
import { benefitsForbiddenWords } from '../..';

import {
  CardContentContainer,
  CardContentFee,
  CardContentTitle,
  CardImgContainer,
  BenefitCardContainer,
  SeparatorLine,
  SpanContent,
  ImgContentContainer,
  CardContent,
  EditButton,
  ButtonIcon,
  RemoveButton,
  FallbackImg,
  NegativeSpanContent,
} from './styles';

type BenefitsCardProps = {
  benefitId: string;
  title: string;
  subtitle: string;
  fee: string | number;
  date: string;
  type?: string;
  imgURL?: string;
  handleEdit?: () => void;
  handleDelete?: () => void;
  negativeFee?: boolean;
};

const BenefitCard: React.FC<BenefitsCardProps> = ({
  imgURL,
  type,
  benefitId,
  title,
  subtitle,
  fee,
  date,
  handleEdit,
  handleDelete,
  negativeFee,
}) => {
  const { t } = useTranslation();

  const editMode = !!handleEdit;
  const deleteMode = !!handleDelete;
  const cardOnEditMode = editMode || deleteMode;

  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.src = fallbackImageUrl;
  };

  return (
    <BenefitCardContainer>
      <ImgContentContainer>
        <CardImgContainer editMode={cardOnEditMode || false}>
          <FallbackImg src={imgURL ?? ''} alt="Fallback Image" onError={handleImageError} />
        </CardImgContainer>
      </ImgContentContainer>
      <CardContentContainer>
        <CardContent>
          <CardContentTitle>{removeForbiddenWords(title, benefitsForbiddenWords)}</CardContentTitle>
          <SpanContent> {date} </SpanContent>
        </CardContent>
        <div style={{ display: 'flex' }}>
          <SeparatorLine />
        </div>
        <CardContent>
          <CardContentFee>{subtitle}</CardContentFee>
          {negativeFee ? <NegativeSpanContent> {fee} </NegativeSpanContent> : <SpanContent> {fee} </SpanContent>}
        </CardContent>

        {(editMode || deleteMode) && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            {deleteMode && (
              <RemoveButton data-testid="remove-button" onClick={handleDelete}>
                <span>{t('global.form.remove')}</span>
                <ButtonIcon src={trashIcon} style={{ marginBottom: '3px' }} />
              </RemoveButton>
            )}
            {editMode && (
              <EditButton data-testid="edit-button" onClick={handleEdit}>
                <span>{t('global.form.edit')}</span>
                <ButtonIcon src={editIcon} style={{ marginBottom: '5px' }} />
              </EditButton>
            )}
          </div>
        )}
      </CardContentContainer>
    </BenefitCardContainer>
  );
};

export default BenefitCard;
